import { createFileRoute } from "@tanstack/react-router";
import { EsLegalPage, EsLegalSection } from "@/components/site/EsPage";
import { buildHead } from "@/lib/seo-head";

export const Route = createFileRoute("/es/legal/privacidad")({
  head: () =>
    buildHead({
      title: "Política de Privacidad — Simply Approved Mortgages",
      description:
        "Qué información recopilamos en este sitio, cómo la usamos, con quién la compartimos y cómo puede solicitar su eliminación o cancelar las comunicaciones.",
      url: "/es/legal/privacidad",
      locale: "es",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Privacidad", url: "/es/legal/privacidad" },
      ],
    }),
  component: Page,
});

function Page() {
  return (
    <EsLegalPage
      title="Política de privacidad"
      intro="Este resumen en español explica qué información recopilamos en este sitio, cómo la usamos y qué control tiene usted sobre ella."
      enPath="/legal/privacy"
      enLabel="Privacy Policy"
    >
      <EsLegalSection heading="Qué recopilamos">
        <p>
          Recopilamos la información que usted nos envía en nuestros formularios: nombre, correo
          electrónico, teléfono, estado y ciudad, y los datos que comparte sobre su escenario de
          inversión (tipo de propiedad, ingresos por renta, precio estimado, entidad de préstamo).
          También registramos la página desde la que envió el formulario, la fecha y la hora, y el
          texto del consentimiento que aceptó.
        </p>
        <p>
          Registramos datos técnicos básicos de uso del sitio (páginas vistas y origen de la visita)
          para entender qué contenido resulta útil.
        </p>
      </EsLegalSection>

      <EsLegalSection heading="Cómo la usamos">
        <p>
          Usamos su información para responder a su consulta, evaluar su escenario de préstamo con
          fines comerciales y comunicarnos con usted sobre su solicitud, tal como lo autorizó al
          enviar el formulario.
        </p>
        <p>
          No vendemos su información. La compartimos únicamente con los proveedores que necesitamos
          para operar (correo electrónico, nuestro sistema de gestión de clientes y, cuando usted
          avanza con una solicitud, el prestamista mayorista correspondiente), y cuando la ley lo
          exige.
        </p>
      </EsLegalSection>

      <EsLegalSection heading="Sus opciones">
        <p>
          Puede cancelar las comunicaciones de marketing en cualquier momento con el enlace de
          cancelación de suscripción que aparece en cada correo, o respondiendo STOP a nuestros
          mensajes de texto. Cancelar el marketing no detiene las comunicaciones necesarias sobre
          una solicitud en curso.
        </p>
      </EsLegalSection>

      <EsLegalSection heading="Estados donde no tenemos licencia">
        <p>
          Si usted indica un estado donde no tenemos licencia para préstamos residenciales a
          consumidores, no le enviamos comunicaciones de marketing hipotecario. Su información se
          conserva únicamente como registro de su interés, por si en el futuro obtenemos licencia en
          su estado, y puede pedirnos que la eliminemos.
        </p>
      </EsLegalSection>
    </EsLegalPage>
  );
}
